import React from 'react';
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {WelcomeUserBox} from "./boxes/welcome-user.box";
import {WelcomeGreetingBox} from "./boxes/welcome-greeting.box";

export const WelcomeUser = observer(class WelcomeUser extends OrbitComponent {
  render() {
    const {translation} = this.services;

    return (
      <WelcomeUserBox className="cy-welcome-user-menu-title">
        <WelcomeGreetingBox>{translation.translate("MY_ACCOUNT")}</WelcomeGreetingBox>
      </WelcomeUserBox>
    );
  }

});
